/**
 * @format
 */
import { api } from '@/scripts/api';

export const GlobalCategoryService = {
    getAll(accountId, config = {}, signal) {
        return new Promise((resolve, reject) => {
            const service = `/ms/categories/v1/categories/${accountId}`;
            const endpoint = api.applyNodeDataParams(service, config);

            api.get(endpoint, signal).then(resolve).catch(reject);
        });
    },

    post(accountId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/categories/v1/categories/${accountId}`;

            api.post(service, payload)
                .then(resolve)
                .catch((error) => {
                    if (!api.isCanceled(error)) {
                        reject(error);
                    }
                });
        });
    },

    delete(accountId, categoryId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/categories/v1/categories/${categoryId}/${accountId}`;

            api.delete(service).then(resolve).catch(reject);
        });
    },
};
